import { render, staticRenderFns } from "./SearchPopUp.vue?vue&type=template&id=1b80601b"
import script from "./SearchPopUp.vue?vue&type=script&lang=js"
export * from "./SearchPopUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports